import React, { Component } from 'react'
import 'element-theme-default';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import { Input, Select, Tabs, Button, Pagination, Checkbox, Radio, Message, Loading, Tooltip, Tag, Dialog, MessageBox } from 'element-react';
import { requests, getToken, loadZhuKeToken, getLoginShopInfo, messageShow, systemConfig,getZkShopName ,getTaoteShopName,funSplitType,matchSupplierProductV2,isNotNull, addDays, formatDate } from '../../utils/http';
import MyLoading from '../../components/showLoading/showLoading';
import '../../assets/css/common.less';
import './index.less';
import ShowWarn from '../../components/showWarn/showWarn';
import ShowNotice from '../../components/showNotice/index';
import SelectCategoryModule from '../../components/selectCategoryModule';
import ShowModal from '../../components/showModal/index.jsx';
import PlatformName from '../../components/platformName/index.jsx';
import NewUserGuide from '../../components/newUserGuide/index.jsx';
import $, { data, parseHTML } from 'jquery'
import { MatchTaoteLinkRequest,AddSiteLogRequest,AddSiteLogByShopRequest,BatchListingMobileByProductIdListV2Request} from '../../utils/api';
import PreviewDistributionList from '../../components/previewDistributionList';
import { douyinInitilize, douyinComponentLoad } from '../../utils/douyinplugin.js';
import { requestNotic} from '../../utils/notic.js';
import { prodctDitributionClickReport,otherExposureReport } from '../../utils/alibabareport.js';
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alibabaPageKey:'link_distribution',
      isLoading: false,
      logAllNumber: 0,
      logDoingNumber: 0,
      logSuccessNumber: 0,
      logErrorNumber: 0,
      shopId: "940556",//当前登录的店铺id，非阿里的
      shopName: "华强北批发",//当前登录的店铺id，非阿里的
      platformType: "TouTiao",//当前登录的店铺id，非阿里的
      isShowNewTag: false,
      isOpenPromotionDialog: false,
     
      courseList: [],//教程列表
      indexRightGongGaoImg: "https://www.dgjapp.com/public/images02/sz4g1644545752648.png",//右边公告图
      indexRightGongGaoUrl: "",//右边公告链接

      index: "0",//首页切换的坐标
      openUrl: "https://s.1688.com/erpoffer/offer_search.html?keywords=&charset=utf8&erp_app_key=8076003",

      urlByProduct: "",
      offerId: "",
      offerIdList: [],
      supplierProductListByBatch: [],//铺货前，获取到的供应商商品列表数据
      affirmByeBatchDistributionByData: {},
      isShowByDistributionSelectCategory: false,//显示铺货前选择的类目--弹窗


      taskCodeRes: { taskCode: '', isPost: false, allNumber: 0, successNumber: 0, errorNumber: 0, "errorList": [] },//铺货后，返回的任务code
      isShowTaskCodeRes: false,
      isShowReachListingCount: false,//是否免费版且铺货超5次的提示

      showSelectCategoryModule: false,//选择类目的弹窗
      isShowNewUserGuide:false,//新用户引导弹出


      funSplitTypes: funSplitType(),

      ciphertextOrderSetDailog:false,
      showPreviewDistributionDailog:false,
      selectPreviewProductList:[],//预览铺货商品表


      supplierProductIds:[],
      fenxiaoProductFaildList:[],
      errorLink:[],
      fenxiaojiaoChengDialog : false,
    };

  }

  componentDidMount() {
   
    douyinInitilize();
    var zhukeToken = getToken();
    //var zhukeToken="";
    var that = this;
    if (zhukeToken != "")
    {
      that.loadData();
      otherExposureReport(that.state.alibabaPageKey);
    }
      
    else {
      setTimeout(() => {
        var zhukeTokenTwo = getToken();
        if (zhukeTokenTwo == "") {
          var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
          //var hasZhukeLoginShopTokens = "";//测试。54CE4081AAE0AFEA121A0FA63D7E0AEA
          if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
            loadZhuKeToken(hasZhukeLoginShopTokens);

            setTimeout(() => {
              var zhukeTokenThree = getToken();
              if (zhukeTokenThree != "")
                that.loadData();              
              else {
                this.setState({
                  isShowWarn: true, isShowNewUserGuide:true
                })
              }
            }, 500);
          } else
          {
            this.setState({ isShowWarn: true, isShowNewUserGuide:true});
          }
        } else
          that.loadData();
      }, 500);

    }

    setTimeout(()=>{ that.addLog('访问链接铺货','to_index_shop');
     
    },2000);
  }

  douyinPromotionInit = () => {
    const currentDate = new Date();
    const targetDate = new Date('2025-08-04'); // 上线日期2025-07-20

    // 展示周期为15天，15天后不再展示该弹窗
    if (currentDate.getTime() < targetDate.getTime()) {
        this.setState({
            isShowNewTag: true
        });

        //每日首次进入首页时弹出该海报弹窗
        //勾选7日内不再提示，后续7天不再弹出
        const isShowPromotion = localStorage.getItem("isTodayShow_Promotion-" + this.state.shopId) || null;
        const nextShowPromotion = localStorage.getItem("nextShow_Promotion-" + this.state.shopId) || null;
        const todayShowPromotion = formatDate(currentDate);

        if (isShowPromotion != todayShowPromotion) {
            // 今天没有弹出过   判断是不是勾选了7日不再提示
            if(nextShowPromotion) {
                // 判断7天不再提示是否已过
                const nextDate = new Date(nextShowPromotion); 
                if (currentDate.getTime() > nextDate.getTime()) {
                    this.setState({
                        isOpenPromotionDialog: true
                    });
                    localStorage.setItem("isTodayShow_Promotion-" + this.state.shopId, todayShowPromotion);
                }
            } else {
                this.setState({
                    isOpenPromotionDialog: true
                });
                localStorage.setItem("isTodayShow_Promotion-" + this.state.shopId, todayShowPromotion);
            }
        }
    } else {
        const isShowPromotion = localStorage.getItem("isTodayShow_Promotion-" + this.state.shopId);
        const nextShowPromotion = localStorage.getItem("nextShow_Promotion-" + this.state.shopId);
        if(isShowPromotion){
            localStorage.removeItem("isTodayShow_Promotion-" + this.state.shopId);
        }
        if(nextShowPromotion){
            localStorage.removeItem("nextShow_Promotion-" + this.state.shopId);
        }
    }
  }
  
  addLog(remark,type){
    const loginToken = localStorage.getItem("hasZhukeLoginShopTokens") || null;
    const platformType = getLoginShopInfo().loginShopPlatformType;
    const loginShopId = getLoginShopInfo().loginShopId;
    const zkToken = getToken();
    const data ={
        SiteType : 'pc',
        OperatorType: type,
        Remark: remark,
        PlatformType:platformType,
        ShopId:loginShopId,
        token:loginToken,
    };
    if(zkToken){
        AddSiteLogRequest(data);
    }else{
        AddSiteLogByShopRequest(data)
    }
  }
  loadData = () => {
    var shopInfo = getLoginShopInfo();
    this.setState({
      shopId: shopInfo.loginShopId,
      shopName: shopInfo.loginShopName,
      platformType: shopInfo.loginShopPlatformType,
    }, () => {
      this.loadLogList();
      this.rightGongGao();
      //requestNotic(shopInfo.loginShopPlatformType);
      if(shopInfo.loginShopPlatformType=="TouTiao")
      {
        douyinComponentLoad(shopInfo.loginShopId,shopInfo.loginShopName,"douyinYingXiaoComponent");
        this.douyinPromotionInit();
      }
      this.getExpireAlibabaZhuke();
    })
  }
  getExpireAlibabaZhuke = () => {
    var data = {
      SystemVersions: 'pc'
    };
    var that = this;
    requests({
      url: "/Common/GetIndexByUserInfo",
      data: data,
      success: (json) => {
        if (json.Success) {
          var result = json.Data;
          var endDay = result.EndDay;
          if (isNotNull(endDay)) {
            var endDayInt = parseInt(endDay);
            if (endDayInt < 8) {
              var hasExpiredShow = localStorage.getItem("hasExpiredShow") || null;
              var todayExpiredShow = "hasExpiredShow" + (new Date().getMonth() - 0 + 1) + new Date().getDay();
              //一天显示一次
              if (hasExpiredShow != todayExpiredShow) {
                var hasDonghua = "hasExpiredShow" + (new Date().getMonth() - 0 + 1) + new Date().getDay();
                localStorage.setItem("hasExpiredShow", hasDonghua);
                MessageBox.msgbox({
                  title: '授权提示',
                  message: <span>1688货源授权即将到期<span style={{ color: "#fa1f07", "fontSize": "16px" }}>剩余7天</span>,请及时续订并授权以免影响您铺货和订单回流</span>,
                  type: 'warning',
                  showCancelButton: false,
                  confirmButtonText: '前往续订并授权'
                }).then((action) => {
                  if (action == 'confirm') {
                    const path = { pathname: '/myAuth', state: { from_action: "alibaba_auth_expire" } }
                    that.props.history.push(path);
                  }
                });
              }
            }
          }
        } else {
  
        }

      },
      fail: (err) => {

      }
    })


  }

  //获取铺货日志列表
  loadLogList = () => {
    var that = this;

    var shopid = this.state.shopId;
    //全部铺货的状态
    var successData = {
      SaleState: "",
      ShopIdList: [shopid]
    }

    requests({
      url: "/Common/GetIndexByDistributionLogNumber",
      data: successData,
      success: (json) => {
        if (json.Success) {
          var numbers = json.Data.Number;
          that.setState({ logAllNumber: numbers });
        }
      },
      fail: (err) => { }
    })

    //铺货中
    var successData = {
      SaleState: "doing",
      ShopIdList: [shopid]
    }

    requests({
      url: "/Common/GetIndexByDistributionLogNumber",
      data: successData,
      success: (json) => {
        if (json.Success) {
          var numbers = json.Data.Number;
          that.setState({ logDoingNumber: numbers });
        }
      },
      fail: (err) => { }
    })


    //铺货成功
    var successData = {
      SaleState: "success",
      ShopIdList: [shopid]
    }
    requests({
      url: "/Common/GetIndexByDistributionLogNumber",
      data: successData,
      success: (json) => {
        if (json.Success) {
          var numbers = json.Data.Number;
          that.setState({ logSuccessNumber: numbers });
        }
      },
      fail: (err) => { }
    })

    //铺货失败
    var successData = {
      SaleState: "error",
      ShopIdList: [shopid]
    }
    requests({
      url: "/Common/GetIndexByDistributionLogNumber",
      data: successData,
      success: (json) => {
        if (json.Success) {
          var numbers = json.Data.Number;
          that.setState({ logErrorNumber: numbers });
        }
      },
      fail: (err) => { }
    })

  }

  //右边公告
  rightGongGao = () => {
    var that = this;
    requests({
      url: "/Common/TopNoticeByIndexRight",
      data: { SystemVersions: "ShopVersionPC" },
      success: (res) => {
        if (res.Success) {
          var rightTop = res.Data.RightTop;
          var rightBelow = res.Data.RightBelow;
          //右边公告
          if (rightTop != null && rightTop != undefined && rightTop != "") {
            var rightTopJson = JSON.parse(rightTop);
            if (rightTopJson.NoticeImg != null && rightTopJson.NoticeImg != undefined && rightTopJson.NoticeImg != "") {
              var indexRightGongGaoImg = rightTopJson.NoticeImg;
              var indexRightGongGaoUrl = "";
              if (rightTopJson.NoticeUrl != null && rightTopJson.NoticeUrl != undefined && rightTopJson.NoticeUrl != "")
                indexRightGongGaoUrl = rightTopJson.NoticeUrl;

              that.setState({ indexRightGongGaoImg: indexRightGongGaoImg, indexRightGongGaoUrl, indexRightGongGaoUrl });
            }
          }
          //右边教程
          if (rightBelow != null && rightBelow != undefined && rightBelow != "") {
            var rightBelowJson = JSON.parse(rightBelow);

            if(that.state.platformType == "TouTiao") {
                rightBelowJson.push({
                    Content: "如何使用1688官方退货服务",
                    ContentUrl: "https://m0ij9216j9.feishu.cn/docx/OMmQddTJOoe71SxU6IpcNLKfnUh?from=from_copylink"
                })
            }

            that.setState({ courseList: rightBelowJson });
          }
          console.log(rightTop);
          console.log(rightBelow);
        }
      },
      fail: (err) => { }
    });

  }

  closePromotionDialog = () => {
    const isCheck = $("#not_askCheckbox").is(':checked');

    // 勾选了【7日不再提示】并关闭弹窗后，后续7天不再弹出该弹窗
    if(isCheck) {
        var currentDate = new Date();
        var newDate = addDays(currentDate, 7);
        var formattedDate = formatDate(newDate);
        localStorage.setItem("nextShow_Promotion-" + this.state.shopId, formattedDate);
    }
    this.setState({ isOpenPromotionDialog: false });
  }


  //查询供应商商品，并开始铺货前的类目显示
  queryAndPuhuoButton = () => {

    var urlValue = this.state.urlByProduct;
    // if (urlValue == "") {
    //   Message({ message: '链接不能为空！', offset: 30, type: "warning" });
    //   return;
    // }

    // if (this.state.isShowWarn) {
    //   Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 30, type: "warning" });
    //   return;
    // }

    // var regx = /detail.1688.com\/offer\/(.*?).html/g;
    // var rs = regx.exec(urlValue);
    // var data = {};

    // if (rs == undefined || rs == null || rs.length < 2 || rs[1] == '') {
    //   var numberRegx = /^[0-9]*$/g;
    //   rs = numberRegx.exec(urlValue);
    //   if (rs == undefined || rs == null || rs.length < 1 || rs[1] == '') {
    //     Message({ message: '请输入正确格式的货源链接(例：https://detail.1688.com/offer/***.html或者商品ID)', offset: 60, type: "warning" });
    //     return;
    //   } else {
    //     data.SupplierProductId = rs[0]
    //   }
    // } else {
    //   data.SupplierProductId = rs[1]
    // }


    // var that = this;
    // that.setState({ isLoading: true });
    // requests({
    //   url: "/Product/LoadSupplierProduct",
    //   data: data,
    //   success: (json) => {
    //     that.setState({ isLoading: false });
    //     if (json.Success) {
    //       var supplierProduct = json.Data.AlibabaProduct;
    //       that.setState({ offerId: supplierProduct.ProductId,offerIdList:[supplierProduct.ProductId] }, () => {
    //         that.distributionPreposition();
    //       })
    //     } else {
    //       Message({
    //         showClose: true,
    //         message: json.Message,
    //         type: 'error'
    //       });
    //     }
    //   },
    //   fail: (err) => {
    //     that.setState({ isLoading: false });
    //   }
    // })

    // var matchSupplierProduct = matchSupplierProductV2(urlValue);
    // const matchList = matchSupplierProduct.supplierProductLinks;
    // const errorLink = matchSupplierProduct.errorLink;
    // var items = [];
    // if (matchList.length > 0) {
    //   matchList.forEach(element => {
    //     if (items.findIndex(s => s.link == element.link) == -1) {
    //       items.push(element);
    //     }
    //   });
    // }
    let items = this.state.supplierProductIds
    if (items.length > 50) {
      Message({ message: '最多支持50个链接', offset: 30, type: "warning" });
      return;
    }
    if (items.length == 0) {
      Message({ message: '匹配链接失败，请选择正确货源链接', offset: 30, type: "warning" });
      return
    }

    var taoteItems = items.filter(s => s.sourcePlatform == 'TaoteZhuKe' && !s.supplierProductId);
    if (taoteItems.length > 0) {
      if(!systemConfig.zhukeTaoteAuth){
        this.taoteAuthExpireDailog(this);
        return;
      }
      var links = taoteItems.map(s => s.link);
      const data = { Links: links }
      MatchTaoteLinkRequest(data).then(res => {
        if (res.Success) {
          if (res.Data.List) {
            items.forEach(s => {
              var product = res.Data.List.find(x => x.Item1 == s.link);
              if (product)
                s.supplierProductId = product.Item2;
            })
          }
          items = items.filter(s => s.supplierProductId);
          if (items.length == 0) {
            Message({ message: '淘口令无效!', offset: 60, type: "warning" });
            return;
          }
          this.distributionPreposition(items);
        }
      });
    } else {
      this.distributionPreposition(items);
    }
  }
  //铺货链接文本框onBlur事件
  supplierProductLinkTxtBlur(e) {
    var value = e.target.value
    var matchSupplierProduct = matchSupplierProductV2(value);
    const matchList = matchSupplierProduct.supplierProductLinks;
    const errorLink = matchSupplierProduct.errorLink;
    var supplierProductIds = this.state.supplierProductIds;
    if (matchList.length > 0) {

        if(matchList.length + supplierProductIds.length > 50)
        {
            messageShow("最多支持50个链接", 'error');
            return;
        }
        matchList.forEach(element => {
            if (supplierProductIds.findIndex(s => s.link == element.link) == -1) {
                supplierProductIds.push(element);
            }
        });
        this.setState({ supplierProductIds: this.state.supplierProductIds, urlByProduct: '', offerIdList: supplierProductIds.map(s => s.supplierProductId) })
    }

    if(errorLink.length > 0){
      for(let link of errorLink)
      {
        if(!this.state.errorLink.includes(link))
        {
          this.state.errorLink.push(link)
        }
      }
    }
    if(!value && this.state.supplierProductIds.length == 0){
      this.state.errorLink = []
    }

    var $div = document.getElementById('distributionTexttAreaWrap');	                 
    $div.scrollTop = $div.scrollHeight;
    $('#distributionTexttAreaWrap').removeClass('distributionTexttAreaWrap-focus')
    this.setState({})
  }
  //删除链接事件
  delSupplierProductLink(link) {
    var index = this.state.supplierProductIds.findIndex(s => s.supplierProductId == link.supplierProductId);
    if (index != -1) {
        this.state.supplierProductIds.splice(index, 1);
        if(this.state.supplierProductIds.length == 0){
          this.state.errorLink = []
        }
        this.setState({ supplierProductIds: this.state.supplierProductIds, offerIdList: this.state.supplierProductIds.map(s => s.supplierProductId) });
    }
  }
  //匹配货源商品Id
  matchSupplierProduct(source) {
    //支持匹配货源商品Id
    var regexForm1688 = /((http|https):\/\/)?(www)?detail.1688.com\/offer\/\d+(.html)?/g;
    var regexFormTaote = /(http|https):\/\/u.ltao.com[^\s\u4e00-\u9fa5]*/g;
    var regexFormTaoteSource = /(http|https):\/\/market.m.taobao.com\/app\/nozomi\/app-h5-detail\/main\/index.html\?id=\d+/g;
    var regexFormTaoteSource2 = /(http|https):\/\/market.m.taobao.com\/app\/ltao-fe\/ltao-lite\/productdetail.html\?ft=t&id=\d+/g;
    var match1688 = source.match(regexForm1688);
    var matchTaote = source.match(regexFormTaote);
    var matchTaoteSource = source.match(regexFormTaoteSource);
    var matchTaoteSource2 = source.match(regexFormTaoteSource2);
    const supplierProductLinks = [];

    if (match1688) {
      var matchSupplierIdReg = /offer\/\d+/;
      match1688.forEach(link => {
        var supplierProductIds = matchSupplierIdReg.exec(link)
        if (supplierProductIds.length > 0) {
          supplierProductLinks.push({
            link: link,
            supplierProductId: supplierProductIds[0].replace('offer/', ''),
            sourcePlatform: "AlibabaZhuKe"
          })
        }
      })
    }
    if (matchTaote) {
      matchTaote.forEach(link => {
        supplierProductLinks.push({
          link: link,
          sourcePlatform: "TaoteZhuKe"
        })
      })
    }
    if (matchTaoteSource) {
      var matchSupplierIdReg = /id=\d+/;
      matchTaoteSource.forEach(link => {
        var supplierProductIds = matchSupplierIdReg.exec(link)
        supplierProductLinks.push({
          link: link,
          supplierProductId: supplierProductIds[0].replace('id=', ''),
          sourcePlatform: "TaoteZhuKe"
        })
      })
    }
    if(matchTaoteSource2){
      var matchSupplierIdReg = /id=\d+/;
      matchTaoteSource2.forEach(link => {
        var supplierProductIds = matchSupplierIdReg.exec(link)
        supplierProductLinks.push({
            link: link,
            supplierProductId: supplierProductIds[0].replace('id=', ''),
            sourcePlatform:"TaoteZhuKe"
        })
      })
    }

    return supplierProductLinks;
  }
  gotoDistributionSet = () => {
    this.props.history.push('/distributionSet');
 }
  //铺货前，检查类目
  distributionPreposition = (items) => {

    var selectShopBySupplier = {
      ShopId: this.state.shopId,
      ShopName: this.state.shopName,
      PlatformType: this.state.platformType,
      CategoryNameShowText: "",
      TargetCates: [],
      IsLoadIng: true,
      IsButtonRed: false,
    };


    var supplierProductList = [];
    supplierProductList.push({
      SupplierLoginId: '',
      SupplierProductId: this.state.offerId,
      SupplierMemberId: ''
    })

    if (items) {
      supplierProductList = items.map(s => {
        return {
          SupplierLoginId: '',
          SupplierProductId: s.supplierProductId,
          SupplierMemberId: '',
          SourcePlatform: s.sourcePlatform
        }
      });
    }
    const alibabaSupplierProducts = supplierProductList.filter(x => x.SourcePlatform == 'AlibabaZhuKe' 
                                                                        || !x.SourcePlatform);
    const taoteSupplierProducts = supplierProductList.filter(x => x.SourcePlatform == 'TaoteZhuKe');
    if(alibabaSupplierProducts.length > 0 && !systemConfig.zhukeAlibabaAuth){
        this.alibabaAuthDailog(this);
        return;
    }
    if(taoteSupplierProducts.length > 0 && !systemConfig.zhukeTaoteAuth){
        this.taoteAuthExpireDailog(this);
        return;
    }

    var data = {
      TargetShopIds: [this.state.shopId],
      SupplierProductList: supplierProductList,
      UniqueKey: ""
    }
    let reqUrl = '/BatchDistribution/VerificationCategoryV2';
    // if(systemConfig.isZk5())
    // {
    //     reqUrl = '/BatchDistribution/VerificationCategoryV2';
    // }
    this.setState({affirmByeBatchDistributionByData: data,isLoading:true});
    var that = this;
    requests({
      // url: "/BatchDistribution/VerificationCategory",
      url: reqUrl,
      data: data,
      success: (json) => {
        that.setState({ isLoading: false });
        if (json.Success) {
          var listSupplierProduct = json.Data.SupplierProducts || [];

          for (let i = 0; i < listSupplierProduct.length; i++) {
            listSupplierProduct[i].ShopData = selectShopBySupplier;
          }
          var state = {};
          var faildList = [];
          var successList = [];
          //点击【开始铺货】时校验是否可以获取到商品信息，获取不到。
          //如果链接列表里面没有可分销的商品，则弹窗提示需要隐藏【继续铺货】按钮
          that.state.supplierProductIds.forEach(s => {
              var index = listSupplierProduct.findIndex(m => m.ProductId == s.supplierProductId);
              if (index == -1) {
                  faildList.push(s);
              } else {
                  successList.push(s)
              }
          })
          if (faildList.length > 0) {
              state.supplierProductListByBatch = listSupplierProduct;
              state.fenxiaojiaoChengDialog = true;
              state.fenxiaoProductFaildList = faildList;
              state.supplierProductIds = successList;
              state.supplierProductListByBatch = listSupplierProduct;
              state.offerIdList = successList.map(s => s.supplierProductId)
          } else {
              state.supplierProductListByBatch = listSupplierProduct;
              state.isShowByDistributionSelectCategory = true;
          }
          

          that.setState(state, () => {
            that.getCategoryBySupplierOne();
          });

        }
        else if(json.ErrorCode=='SHOP_EXPIRED')
        {          
          messageShow(json.Message, 'error');
          return;
        }
        else if(json.ErrorCode="COMMON_ERROR")
        {
          messageShow(json.Message, 'error');
          return;
        }
        else if(json.ErrorCode=='NOT_FREIGHT_TEMPLATE')
        {
          this.setState({
            isShowNotFreightTemplate: true,
            notFreightTemplateValue: json.Message
          });
          return;
        }
        else if (json.ErrorCode == 'ReachListingCount') {
          MessageBox.confirm(<div>
            <div>
              根据1688货源分销规则，使用1688免费版【铺货代发】
              授权货源最多只能铺货5次。订购1688【<a className='defColor' href='https://pc.1688.com/product/detail.htm?spm=a26370.isv_inner_8076003.0.0.5200YeNJYeNJRU&productCode=FLjfKOZUVVsdPaSNpobsgo5MSv%2BCKZ62omVo8x4qfKc%3D&productType=GROUP&mkey=k_12039404' target={'_blank'}>铺货代发</a>】高级版授权，不限铺货次数。
            </div>
            <div style={{ "marginTop": "16px" }}>
              特别说明:免费版、高级版指1688货源端【铺货代发】
            </div>
          </div>, '提示', {
            customClass: 'home_reach_listing_count_dailog',
            confirmButtonText: "订购高级版"
          }).then(() => {
            window.open('https://pc.1688.com/product/detail.htm?spm=a26370.isv_inner_8076003.0.0.5200YeNJYeNJRU&productCode=FLjfKOZUVVsdPaSNpobsgo5MSv%2BCKZ62omVo8x4qfKc%3D&productType=GROUP&mkey=k_12039404');
          });
        }
        else {
          var state = {};
          state.fenxiaojiaoChengDialog = true;
          state.fenxiaoProductFaildList = that.state.supplierProductIds;
          state.supplierProductIds = [];
          state.offerIdList = []
          this.setState(state)
          // Message({
          //   showClose: true,
          //   message: json.Message,
          //   type: 'error'
          // });
        }
      },
      fail: (err) => {
        that.setState({ isLoading: false });
      }
    })
  }

  //按店铺，
  getCategoryBySupplierOne = () => {
    var productList = this.state.supplierProductListByBatch;
    var lunxunList = [];
    for (let i = 0; i < productList.length; i++) {
      var shop = productList[i].ShopData;
      var shopIdL = [];
      shopIdL.push(shop.ShopId);

      lunxunList.push({
        TargetShopIds: shopIdL,
        SourceProductId: productList[i].ProductId,
        SourceCateId: productList[i].CategoryId,
        SourceCateName: productList[i].CategoryName,
        SourcePlatform: productList[i].PlatformType,
        ProductTitle: productList[i].Subject,
        UseCustom: true,
      })
    }

    //任务发出去，按商品的维度
    for (var i = lunxunList.length - 1; i >= 0; i--) {
      this.lunxunByShopCategory(lunxunList[i]);
    }
  }


  lunxunByShopCategory = (dates) => {
    var data = dates;
    var that = this;
    requests({
      url: "/BatchDistribution/GetMatchingCategory",
      data: data,
      success: (json) => {
        if (json.Success) {
          //成功后，把类目的赋值上
          var resList = json.Data.MatchingShops;
          if (resList == null || resList == undefined)
            resList = [];

          that.lunxunDataResult(dates, resList);
        } else {
          that.lunxunDataResult(dates, []);
        }
      },
      fail: (err) => {
        that.lunxunDataResult(dates, []);
      }
    })
  }

  //轮回获取类目的结果拼接
  lunxunDataResult = (dates, resList) => {
    var productList = this.state.supplierProductListByBatch;
    for (let i = 0; i < productList.length; i++) {
      if (dates.SourceProductId == productList[i].ProductId) {
        var shop = JSON.parse(JSON.stringify(productList[i].ShopData));
        var targetCatesList = [];
        var platformRecommendId="";
        for (let k = 0; k < resList.length; k++) {
          if (resList[k].TargetCates == null || resList[k].TargetCates == undefined)
          {
            targetCatesList = [];
            platformRecommendId=resList[k].PlatformRecommendId;
          }
          else
          {
            targetCatesList = resList[k].TargetCates;
            platformRecommendId=resList[k].PlatformRecommendId;
          }
          break;
        }
        var textValue = "";
        if (targetCatesList.length > 0) {
          targetCatesList.forEach((cc) => {
            textValue += cc.Name + '—';
          })
        }
        shop.TargetCates = targetCatesList;
        shop.PlatformRecommendId=platformRecommendId;
        shop.CategoryNameShowText = textValue.substr(0, textValue.length - 1);
        shop.IsLoadIng = false;
        productList[i].ShopData = shop;
        break;
      }
    }
    this.setState({ supplierProductListByBatch: productList });
  }

  //选择类目
  editMapping = (productId, Id, platformType) => {

    this.setState({
      selectCategoryByProductId: productId,
      //selectCategoryByShopId: Id,
      //selectCategoryByPlatform: platformType,
      showSelectCategoryModule: true,
    });
  }

  //组件传回
  selectCategory = (cateList, selecCatetTitle) => {
    this.setState({ showSelectCategoryModule: false });

    var textValue = "";
    if (cateList != null && cateList != undefined && cateList != null) {
      if (cateList.length > 0) {
        for (let i = 0; i < cateList.length; i++) {
          textValue += cateList[i].Name + '—';
        }
      }
    }

    var supplierCateId = 0;
    var supplierCateName = "";
    var sourcePlatformType = "";
    var supplierProductListByBatch = this.state.supplierProductListByBatch;

    for (let i = 0; i < supplierProductListByBatch.length; i++) {
      if (supplierProductListByBatch[i].ProductId == this.state.selectCategoryByProductId) {
        var shopData = JSON.parse(JSON.stringify(supplierProductListByBatch[i].ShopData));
        shopData.CategoryNameShowText = textValue.substr(0, textValue.length - 1);
        shopData.TargetCates = cateList;
        shopData.IsButtonRed = false;
        supplierCateId = supplierProductListByBatch[i].CategoryId;
        supplierCateName = supplierProductListByBatch[i].CategoryName;
        sourcePlatformType = supplierProductListByBatch[i].PlatformType;

        supplierProductListByBatch[i].ShopData = shopData;
      }
    }


    var datas = {
      SupplierCateId: supplierCateId,
      SupplierCateName: supplierCateName,
      SourcePlatform: sourcePlatformType,
      TargetShopId: this.state.shopId,
      TargetPlatform: this.state.platformType,
      TargetCateItems: cateList
    }


    //先隐藏，已实现，等选择类目组件做好后可以放开
    this.setState({ isLoading: true, loadingTitle: '保存类目...' })
    var that = this;
    requests({
      url: "/CateMapping/SaveCateMapping",
      data: datas,
      success: function (res) {
        that.setState({ isLoading: false })

        if (res.Success) {
          messageShow("保存类目成功", "success");
          that.setState({ supplierProductListByBatch: supplierProductListByBatch });
        } else
          messageShow("保存类目失败：" + res.Message, "error");

      },
    });
  }


  //立即铺货
  affirmByeBatchDistribution = () => {
    var productList = this.state.supplierProductListByBatch;
    var isNotSelect = false;
    for (let i = 0; i < productList.length; i++) {
      var shop = JSON.parse(JSON.stringify(productList[i].ShopData));
      if (shop.TargetCates.length == 0) {
        shop.IsButtonRed = true;
        isNotSelect = true;
      }

      productList[i].ShopData = shop;
    }

    if (isNotSelect) {
      this.setState({ supplierProductListByBatch: productList });
      Message({ message: '请选择商品类目！', offset: 60, type: "warning" });
      return;
    }

    var data = this.state.affirmByeBatchDistributionByData;
    var reportPid=[];
    data.Features = {}
    data.Features.BatchListingFeaturesList = productList.map(x => {
      if(reportPid.includes(x.ProductId) == false){
        reportPid.push(x.ProductId);
      }

      return {
          CatePathList : x.ShopData.TargetCates.map(o => { return { CateId:o.Id,CateName:o.Name  }}),
          PlatformRecommendId:x.ShopData.PlatformRecommendId,
          ShopId:x.ShopData.ShopId,
          SupplierProductId : x.ProductId,
          SourcePlatform : x.PlatformType
      }
    })
    
    prodctDitributionClickReport(reportPid,this.state.alibabaPageKey)
    var allNum = data.TargetShopIds.length * data.SupplierProductList.length; //不用data.SupplierProductList这个，是因为有uniqueKey 的时候，会置空

    //目前不按云平台，统一铺货。
    this.setState({ isLoading: true, loadingTitle: '正在铺货中...' });
    let reqUrl = "/BatchDistribution/BatchListingMobileByProductIdListV2";
    // if(systemConfig.isZk5())
    // {
    //     reqUrl = "/BatchDistribution/BatchListingMobileByProductIdListV2";
    // }
    var that = this;
    requests({
      url: reqUrl,
      data: data,
      success: (res) => {
        if (res.Success) {
          var taskCodeRes = that.state.taskCodeRes;
          taskCodeRes.taskCode = res.Data;
          taskCodeRes.isPost = true;
          taskCodeRes.allNumber = allNum;

          that.setState({ taskCodeRes: taskCodeRes }, () => {
            that.sureBatchDistributionPostTaskCode();
          });



        } else {
          that.setState({ isLoading: false });
          //已超过免费的铺货数量
          if (res.ErrorCode == "ReachListingCount")
            // that.setState({ isShowReachListingCount: true });
            MessageBox.alert('您已成功铺货5次，达到免费版工具铺货上限，升级工具，不限铺货次数；已铺货成功商品订单回流采购不受影响。', '提示');
          else {
            var errResList = [];
            errResList.push("(1)" + res.Message);

            that.sureBatchDistributionPostRes(taskCodeRes.allNumber, errResList.length, errResList);
          }
        }
      },
      fail: (err) => {
        that.setState({ isLoading: false });
      }
    })

  }

  //轮巡  铺货任务的处理。
  sureBatchDistributionPostTaskCode = () => {
    var taskCodeRes = this.state.taskCodeRes;

    var that = this;

    requests({
      url: "/Common/GetZhuKeReqTask",
      data: { TaskCode: taskCodeRes.taskCode },
      success: (res) => {
        if (res.Success) {
          var dates = res.Data;
          if (dates.FinishedTime != null && dates.FinishedTime != "" && dates.FinishedTime != undefined) {
            that.setState({ isLoading: false });
            if (dates.Status == "Error") {
              var errResList = [];
              let errMessage = dates.ErrorMsg;
              if(!errMessage)
              {
                errMessage = '创建任务失败';
              }
              errResList.push("(3)" + errMessage);

              that.sureBatchDistributionPostRes(0, taskCodeRes.allNumber, errResList);
            } else {

              var rspContentJson = JSON.parse(dates.RspContent);
              var errorList = rspContentJson == null || (rspContentJson != null && rspContentJson.ErrorList == null) ? [] : rspContentJson.ErrorList;

              that.sureBatchDistributionPostRes(taskCodeRes.allNumber - errorList.length, errorList.length, errorList);

            }
          } else {

            setTimeout(() => {
              that.sureBatchDistributionPostTaskCode();
            }, 1000);
          }
        } else {
          var errResList = [];
          errResList.push("(2)" + res.Message);

          that.sureBatchDistributionPostRes(0, taskCodeRes.allNumber, errResList);
        }
      },
      fail: (err) => {
        taskCodeRes.isPost = false;
        taskCodeRes.taskCode = '';
        that.setState({ isLoading: false, taskCodeRes: taskCodeRes })
      }
    })
  }

  //铺货任务 结果
  sureBatchDistributionPostRes = (successNumber, errorNumber, errorList) => {

    var taskCodeRes = this.state.taskCodeRes;

    taskCodeRes.isPost = false;

    taskCodeRes.successNumber = successNumber;
    taskCodeRes.errorNumber = errorNumber;
    taskCodeRes.errorList = errorList;
    taskCodeRes.taskCode = '';
    this.state.urlByProduct = "";
    this.setState({ isShowTaskCodeRes: true, taskCodeRes: taskCodeRes, isShowByDistributionSelectCategory: false });
    // MessageBox.alert('铺货任务已提交，可在【铺货日志】中查看铺货结果。', '提示');
  }
  //公共关闭
  cancelModul = (typeName) => {
    this.setState({
        [typeName]: false
    })
  }
  closeShowNewUserGuide=()=>{
    this.setState({isShowNewUserGuide:false})
  }
  successAuthBuyerShop=()=>{
    this.setState({isShowWarn:false})
  }

  onChangeForm = (name, value) => {
    let obj = {};
    obj[name] = value;
    this.setState(obj);
  }
  changeInput = (name, value) => {
    let obj = {};
    obj[name] = value.trim();
    this.setState(obj);
  }

  //切换（链接上货，找货源）
  changeTabs = (obj) => {
    let index = obj.props.name;
    this.setState({ index: index });
  }
  changeNav = (name) => {
    this.props.history.replace(name)
  }
  //公共关闭
  closeModal = (modalName) => {
    this.setState({
      [modalName]: false
    })
  }

  /**淘特授权过期跳转对话框 */
  taoteAuthExpireDailog(that) {
    MessageBox.msgbox({
        title: '授权提示',
        message: <span>当前操作需要获得<span style={{ color: "#fa1f07", "fontSize": "16px" }}>淘特货源授权</span>，您未获得淘特授权或者授权失效，请先进行授权</span>,
        type: 'info',
        showCancelButton: false,
        confirmButtonText: '去授权'
    }).then((action) => {
        if (action == 'confirm') {
            const path = { pathname: '/myAuth', state: { from_action: "taote_auth_expire" } }
            that.props.history.push(path);
        }
    })
  }
  /**淘特授权过期跳转对话框 */
  alibabaAuthDailog(that) {
    MessageBox.msgbox({
        title: '授权提示',
        message: <span>当前操作需要获得<span style={{ color: "#fa1f07", "fontSize": "16px" }}>1688货源授权</span>，您未获得1688授权或者授权失效，请先进行授权</span>,
        type: 'info',
        showCancelButton: false,
        confirmButtonText: '去授权'
    }).then((action) => {
        if (action == 'confirm') {
            const path = { pathname: '/myAuth', state: { from_action: "alibaba_auth_expire" } }
            that.props.history.push(path);
        }
    })
  }
  async showPreviewDistributionList(){
    var urlValue = this.state.urlByProduct;
    if (urlValue == "") {
      Message({ message: '链接不能为空！', offset: 30, type: "warning" });
      return;
    }
    console.log('aaa');

    var matchList = this.matchSupplierProduct(urlValue);
    var items = [];
    if (matchList.length > 0) {
      matchList.forEach(element => {
        if (items.findIndex(s => s.link == element.link) == -1) {
          items.push(element);
        }
      });
    }
    if (items.length > 10) {
      Message({ message: '预览铺货最多支持10个链接', offset: 30, type: "warning" });
      return;
    }
    if (items.length == 0) {
      Message({ message: '匹配链接失败，请选择正确货源链接', offset: 30, type: "warning" });
      return
    }

    var taoteItems = items.filter(s => s.sourcePlatform == 'TaoteZhuKe' && !s.supplierProductId);
    if (taoteItems.length > 0) {
      if(!systemConfig.zhukeTaoteAuth){
        this.taoteAuthExpireDailog(this);
        return;
      }
      var links = taoteItems.map(s => s.link);
      const data = { Links: links }
      MatchTaoteLinkRequest(data).then(res => {
        if (res.Success) {
          if (res.Data.List) {
            items.forEach(s => {
              var product = res.Data.List.find(x => x.Item1 == s.link);
              if (product)
                s.supplierProductId = product.Item2;
            })
          }
          items = items.filter(s => s.supplierProductId);
          if (items.length == 0) {
            Message({ message: '淘口令无效!', offset: 60, type: "warning" });
            return;
          }
          let selectPreviewProductList= items.map(x => {
            return {
              ProductId : x.supplierProductId,
              SourcePlatform : x.sourcePlatform,
            }
          })
          this.setState({
            selectPreviewProductList,
            showPreviewDistributionDailog: true,
          })
        }
      });
    } else {
      let selectPreviewProductList= items.map(x => {
        return {
          ProductId : x.supplierProductId,
          SourcePlatform : x.sourcePlatform,
        }
      })
      this.setState({
        selectPreviewProductList,
        showPreviewDistributionDailog: true,
      })
    }
  }
  previewSureBatchPuhuo= async(listingProducts)=>{
    this.state.showPreviewDistributionDailog = false
    console.log('listingProducts =>',listingProducts)
    let supplierProductList = listingProducts.map(x => { return { 
        SupplierProductId : x.supplierProduct.ProductId,
        SourcePlatform : x.supplierProduct.PlatformType
    }})
    const data = {
        TargetShopIds:[getLoginShopInfo().loginShopId],
        SupplierProductList:supplierProductList,
        ProductTag :'',
        Features : {}
    }
    data.Features.BatchListingFeaturesList = listingProducts.map(x => {
        return {
            CatePathList : x.catePathList,
            RelationCode : x.RelationCode,
            Title : x.supplierProduct.Subject,
            ShopId:getLoginShopInfo().loginShopId,
            SupplierProductId : x.supplierProduct.ProductId,
            SourcePlatform : x.supplierProduct.PlatformType
        }
    })
    if (this.state.selectPlatformNav == 'jxhy')
        data.ProductTag = 'pifatuan';
    var allNum = listingProducts.length; //不用data.SupplierProductList这个，是因为有uniqueKey 的时候，会置空

    //目前不按云平台，统一铺货。
    this.setState({ isLoading: true, isShowChooseShopModul: false, loadingTitle: '正在铺货中...' })
    const res = await BatchListingMobileByProductIdListV2Request(data)
    const taskCodeRes = this.state.taskCodeRes;   //:{taskCode:'',isPost:false,successNumber:0,errorNumber:0,errorList:[]}
    if (res.Success) {
        taskCodeRes.taskCode = res.Data;
        taskCodeRes.isPost = true;
        taskCodeRes.allNumber = allNum;

        this.setState({ taskCodeRes: taskCodeRes });

        setTimeout(() => {
            //只负责把任务赋值上。不做轮训，轮训交由检查接口那里做
            this.sureBatchDistributionPostTaskCode();
        }, 1000);
    } else {
        this.setState({ isLoading: false })

        //已超过免费的铺货数量
        if (res.ErrorCode == "ReachListingCount")
            this.setState({ isShowReachListingCount: true });
        else {
            var errResList = [];
            errResList.push("(1)" + res.Message);
            this.sureBatchDistributionPostRes(taskCodeRes.allNumber, errResList.length, errResList);
        }
    }

  }
  cancelPreviewDistribution=()=>{
      this.setState({showPreviewDistributionDailog:false})

  }



  render() {
    return (
      <div className='wrap'>
        <HeaderMenu isShowNewUserGuide={true} />
        <main>
          <div className='wrap-left scroll-x' >
            <NavMenu changeNav={this.changeNav} defaultActive={"/index"} />
            
          </div>
          <div className="wrap-right">
          <ShowWarn isShow={this.state.isShowWarn} targetUrl={this.changeNav} 
                                    from_action={systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' :null} 
                                    alibabaNickName={getZkShopName()} taoteNickName={getTaoteShopName()}/>
            
            {/* this.state.platformType == "KuaiShou" ?
              <div className='tagDanger' style={{ marginBottom: "5px", padding: '8px' }}>
                <div>
                  <span>官方公告:延迟发货、虚假发货、虚假轨迹专项治理，请各位商家立即开展相关自査整改工作。<a className='defColor' href="https://edu.kwaixiaodian.com/rule/web/detail?id=R9DP9fGJS9" target='_blank'>了解详情</a></span>
                </div>

              </div> : null
            */}
            <div id="notic_show" ></div>

          <ShowNotice></ShowNotice>                                    
            <div className='indexWrap'>
              {/* <div className='tagDanger' style={{display:'none'}}>
                {
                  this.state.funSplitTypes !=2?
                  <div>
                    <span>紧急通知！！！采购下单功能即将下线！因快手平台规则限制，一个应用不允许同时出现铺货和采购下单两个功能，应用将于9月21日进行整改，整改后，用户可通过快手店管家铺货助手正常使用铺货功能，但无法使用采购下单功能，采购下单功能将进行迁移，新应用筹备中，详情请联系客服 </span>
                     <a className='defColor' href="https://open.kwaixiaodian.com/announcement/detail?cateId=all&pageSign=6c733b7d66346a9b7667d065be84160a1694662707481" target='_blank'>公告详情</a>
                  </div>:null
                }
                
              </div> */}

              <div style={{display:'flex',width:'100%'}}>
                <div className='indexWrap-left'>
                  {/* 中间第一部分 */}
                  <div className='indexWrap-partOne'>

                    {/* 二期的，先隐藏后面再放开 */}
                    {/* <div className='indexWrap-partOne-item mywrap'>
                      <div className='partOne-item-title'>
                        <span className='partOne-item-title-name'>代销订单</span>
                        <span className='partOne-item-title-btn'>同步订单<i className='iconfont icon-tongbu'></i></span>
                      </div>
                      <div className='partOne-item-content'>
                        <div className='partOne-item-contentItem'>
                          <span>待采购</span>
                          <span className='partOne-item-contentItem-num'>{this.state.logDoingNumber}</span>
                        </div>
                        <div className='partOne-item-contentItem'>
                          <span>待付款</span>
                          <span className='partOne-item-contentItem-num'>{this.state.logSuccessNumber}</span>
                        </div>
                      </div>
                    </div>
                    <div className='indexWrap-partOne-item mywrap' style={{ margin: "0 15px 15px 15px" }}>
                      <div className='partOne-item-title'>
                        <span className='partOne-item-title-name'>代销商品</span>
                      </div>
                      <div className='partOne-item-content'>
                        <div className='partOne-item-contentItem'>
                          <span>代销中</span>
                          <span className='partOne-item-contentItem-num'>{this.state.logDoingNumber}</span>
                        </div>
                        <div className='partOne-item-contentItem'>
                          <span>缺货</span>
                          <span className='partOne-item-contentItem-num'>{this.state.logSuccessNumber}</span>
                        </div>
                      </div>
                    </div> */}

                    <div className='indexWrap-partOne-item mywrap'>
                      <div className='partOne-item-title'>
                        <span className='partOne-item-title-name'>铺货日志</span>
                      </div>
                      <div className='partOne-item-content'>
                        <div className='partOne-item-contentItem'>
                          <span>全部</span>
                          <span className='partOne-item-contentItem-num'>{this.state.logAllNumber}</span>
                        </div>
                        <div className='partOne-item-contentItem'>
                          <span>铺货中</span>
                          <span className='partOne-item-contentItem-num'>{this.state.logDoingNumber}</span>
                        </div>
                        <div className='partOne-item-contentItem'>
                          <span>铺货成功</span>
                          <span className='partOne-item-contentItem-num'>{this.state.logSuccessNumber}</span>
                        </div>
                        <div className='partOne-item-contentItem'>
                          <span>铺货失败</span>
                          <span className='partOne-item-contentItem-num'>{this.state.logErrorNumber}</span>
                        </div>
                      </div>
                    </div>

                  </div>

                  {/* 中间第二部分 */}
                  <div className='indexWrap-partTwo mywrap'>
                    <Tabs value="0" onTabClick={this.changeTabs.bind(this)}>
                      <Tabs.Pane label="链接上货" name="0"></Tabs.Pane>
                      <Tabs.Pane label="找货源" name="1"></Tabs.Pane>
                    </Tabs>


                    {/* {
                      this.state.index == "0" && !systemConfig.isZk5()?
                        <div className='indexWrap-partTwo-main'>
                          <div className='indexWrap-partTwo-main-warn'>在下方输入框内输入商品链接<a href='https://www.yuque.com/books/share/3b4df780-dec2-401c-8522-a75feeb63766/gtpzq3' className='defColor' target='_blank'>链接铺货注意事项</a></div>
                          <Input type="textarea" value={this.state.urlByProduct} onChange={this.changeInput.bind(this, 'urlByProduct')}
                            placeholder="请输入1688货源链接"
                          />
                          <div style={{"marginTop":"20px","display":"flex","alignItems":"center"}}>
                            <span style={{"fontSize":"14px","fontWeight":"600"}}>支持平台：</span>
                            <span  style={{"display":"flex","gap":"8px"}}>
                              <img src="https://www.dgjapp.com/public/images/kaifang/alibaba_logo.png" alt="" width={"40px"} height={"40px"} />
                            </span>
                          </div>
                          <Button className='indexWrap-partTwo-Btn' type="primary" size="large" onClick={() => this.queryAndPuhuoButton()}><i style={{marginRight:"5px"}} className='iconfont icon-buzhou'></i>开始铺货</Button>
                        </div> : null
                    } */}
                    {
                      this.state.index == "0"?
                        <div className='indexWrap-partTwo-main'>
                          <div className='indexWrap-partTwo-main-warn'>
                          <span>在下方输入框内粘贴1688商品链接，每次最多可上传<i style={{ color: "#f7941f" }}>50</i>条链接</span>
                          {/* 视频号新应用,发布视频号时这个要注释掉 */}
                          <a href='https://www.yuque.com/books/share/3b4df780-dec2-401c-8522-a75feeb63766/gtpzq3' className='defColor' target='_blank'>链接铺货注意事项</a>
                          </div>
                          {/* <Input type="textarea" value={this.state.urlByProduct} onChange={this.changeInput.bind(this, 'urlByProduct')}
                            placeholder="请输入1688货源链接或者淘特口令"
                          /> */}
                          <div className='distributionTexttAreaWrap scroll-x' id="distributionTexttAreaWrap">
                            <div className="" style={{height: "180px",overflowY: "auto"}}>
                            <ul className='distributionTexttAreaWrap-ul'>
                                  {
                                      this.state.supplierProductIds.map((item, index) => {
                                          return <li className='distributionTexttAreaWrap-ul-li'>
                                              <span className='distributionTexttAreaWrap-ul-li-text'>{item.link}</span>
                                              <i className='iconfont icon-jia-copy1' onClick={(e) => this.delSupplierProductLink(item)}></i>
                                          </li>
                                      })
                                  }
                              </ul>
                              <textarea name="" value={this.state.urlByProduct} placeholder={this.state.supplierProductIds.length === 0 ? '请输入1688货源链接' : ''}
                                  onBlur={(e) => { this.supplierProductLinkTxtBlur(e) }}
                                  onFocus={()=>{ $('#distributionTexttAreaWrap').addClass('distributionTexttAreaWrap-focus') }}
                                  onChange={(e) => { this.onChangeForm('urlByProduct', e.target.value) }}>

                              </textarea>
                            </div>
                              
                              <div>
                              {
                                this.state.errorLink.length > 0?
                                <div className='defTip' >
                                  <i className='iconfont icon-shanchu' style={{color: "#fff",}}></i>
                                  <span>当前仅支持1688商品链接，您提交的
                                    {this.state.errorLink.length+this.state.supplierProductIds.length}条链接中有{this.state.errorLink.length}条不符合规则，已过滤</span>
                                  <span onClick={()=>{ this.onChangeForm('errorLinkDailog',true)}} className='hover defColor'> 查看详情</span>
                                </div>:null
                              }
                            </div>
                                  
                          </div>
                          {/* {
                            !this.state.urlByProduct && this.state.supplierProductIds.length == 0 ? 
                            <a href='https://docs.qq.com/doc/DYm5seUFNaFdPZ1ls' style={{"position":"absolute","display":"block","marginLeft":"230px","marginTop":"-140px"}} className='defColor' target='_blank'>如何获取淘特口令上货？</a>:null
                            
                          } */}
                          
                          <div style={{"marginTop":"20px","display":"flex","alignItems":"center"}}>
                            <span style={{"fontSize":"14px","fontWeight":"600"}}>支持平台：</span>
                            <span  style={{"display":"flex","gap":"8px"}}>
                              <img src="https://www.dgjapp.com/public/images/kaifang/alibaba_logo.png" alt="" width={"40px"} height={"40px"} />
                              {/* <img src="https://www.dgjapp.com/public/images/kaifang/taote_logo.png" alt="" width={"40px"} height={"40px"} /> */}
                            </span>
                          </div>
                          <Button className='indexWrap-partTwo-Btn' type="primary" size="large" onClick={() => this.queryAndPuhuoButton()}><i style={{marginRight:"5px"}} className='iconfont icon-buzhou'></i>开始铺货</Button>
                          {/* <Button className='indexWrap-partTwo-Btn' size="large" onClick={() => this.showPreviewDistributionList()}><i style={{marginRight:"5px"}} className='iconfont icon-buzhou'></i>预览铺货</Button> */}
                        </div> : null
                    }
                    {
                      this.state.index == "1" ?
                        <div>
                          <iframe style={{ width: "100%", height: "700px", border: "unset" }} src={this.state.openUrl}></iframe>
                        </div> : null
                    }
                  </div>
                </div>
                <div className='indexWrap-right'>

                  <div className='partOne02-item mywrap'>
                    <div className='partOne02-item-title'>
                      <span className='partOne02-item-title-name'>公告</span>
                    </div>
                    <div className='partOne02-item-content'>
                      {/* 视频号新应用,发布视频号时这个要注释掉 */}
                      <a style={{ cursor: "pointer" }} href={this.state.indexRightGongGaoUrl == "" ? "javascript:void(0);" : this.state.indexRightGongGaoUrl} target={this.state.indexRightGongGaoUrl == "" ? "" : "_blank"} >
                        <img style={{ width: "230px", height: "110px" }} src={this.state.indexRightGongGaoImg} alt="" />
                      </a>
                    </div>
                  </div>
                  <div className='partOne02-item mywrap' style={{ height: "380px" }}>
                    <div className='partOne02-item-title'>
                      <span className='partOne02-item-title-name'>使用教程</span>
                    </div>
                    <div className='partOne02-item-content' style={{height: 'unset', position: 'relative'}}>
                      {/* 视频号新应用,发布视频号时这个要注释掉 */}
                      {
                        this.state.courseList.map((item) =>
                          <a className='partOne02-content-item' key={item.ContentUrl} style={{ cursor: "pointer" }} href={item.ContentUrl == "" ? "javascript:void(0);" : item.ContentUrl} target={item.ContentUrl == "" ? "" : "_blank"}>{item.Content}</a>
                        )
                      }
                      {this.state.isShowNewTag ? <span className='partOne02-item-newTab'>new</span> : null}
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </main>

        {/* 弹窗 ，铺货前的类目选择 */}
        <Dialog
          title="默认智能匹配类目，智能匹配未匹配上时需手动选择商品类目"
          size="tiny"
          visible={this.state.isShowByDistributionSelectCategory}
          onCancel={() => this.setState({ isShowByDistributionSelectCategory: false })}
          lockScroll={false}
          customClass="distributionSelectCategoryDialog"
        >
          <Dialog.Body>
            <div className='distributionSelectCategory-main'>
              <div className="showModalWrap-box-commonContent">
                {
                  this.state.supplierProductListByBatch.map((item) =>
                    <div className='supplierProductWrap'>
                      <div className='supplierProductWrap-info'>
                        <img style={{ width: '60px', height: '60px' }} src={item.PicURI == null || item.PicURI == "" ? 'https://cbu01.alicdn.com/images/cn/market/myalibaba/newmyali/nopic.gif' : item.PicURI} alt="" />
                        <div className='supplierProductWrap-info-left'>
                          <span>

                            {item.Subject}
                          </span>
                          <span style={{ marginTop: "5px", color: "#f7941f" }}>类目：{item.CategoryName}</span>
                        </div>

                      </div>
                      <div className='supplierProductWrap-table'>
                        <div className='supplierProductWrap-table-tr'>
                          <div className='supplierProductWrap-shopName'>
                            <PlatformName platformType={item.ShopData.PlatformType} iconSize={"tinyIcon"} isHidePatformName={true} />
                            <span>{item.ShopData.ShopName}</span>
                          </div>
                          {
                            item.ShopData.IsLoadIng ?
                              <div className='supplierProductWrap-operate'>
                                <span style={{ color: "#888" }}>加载中</span>
                                <img style={{ width: 25, height: 25, marginRight: "3rem" }} src="https://dgjapp.com/public/images/zhipoIcon/timg02.gif" />
                              </div>
                              : <div className='supplierProductWrap-operate' onClick={() => this.editMapping(item.ProductId, item.ShopData.ShopId, item.ShopData.PlatformType)}>
                                {
                                  item.ShopData.TargetCates.length == 0 && item.ShopData.IsButtonRed == true ?
                                    <div className='supplierProductWrap-choseRight' style={{ color: "#fe6f4f" }}>
                                      <span className='supplierProductWrap-text'>请选择类目</span>
                                      <span className='iconfont icon-xiangxia'></span>
                                    </div>
                                    : item.ShopData.TargetCates.length == 0 && item.ShopData.IsButtonRed == false ?
                                      <div className='supplierProductWrap-choseRight' >
                                        <span className='supplierProductWrap-text' style={{ color: "#ccc" }}>请选择类目</span>
                                        <span className='iconfont icon-xiangxia'></span>
                                      </div>
                                      : <div className='supplierProductWrap-choseRight'>
                                        <span className='supplierProductWrap-text'>{item.ShopData.CategoryNameShowText}</span>
                                        <span className='iconfont icon-xiangxia'></span>
                                      </div>
                                }
                              </div>
                          }


                        </div>
                      </div>
                    </div>
                  )
                }



              </div>
              <div className="showModalWrap-box-commonfooter">
                <Button size="medium" type="primary" onClick={() => this.affirmByeBatchDistribution()}>立即铺货</Button>
                <Button size="medium" onClick={() => this.closeModal("isShowByDistributionSelectCategory")}>取消</Button>
              </div>

            </div>
          </Dialog.Body>
        </Dialog>



        {/* <Dialog
          title="添加货源授权"
          size="tiny"
          visible={this.state.isShowTaskCodeRes}
          onCancel={() => this.setState({ isShowTaskCodeRes: false })}
          lockScroll={false}
          customClass="authorizationDialogWrap"
        >
          <Dialog.Body>
            <div className='distributionSelectCategory-main showModalWrap'>
              
            </div>
          </Dialog.Body>
        </Dialog> */}

        {/* 铺货结果 */}
        <ShowModal width={"500px"} showModal={this.state.isShowTaskCodeRes} hideBtn={true} showLeftTopBtn={true} cancelDailog={() => this.cancelModul("isShowTaskCodeRes")} >
          <div className="showModalWrap-box-commonContent" style={{ padding: "25px" }}>
              <div className="showModalWrap-commonContent-item" style={{ marginBottom: "25px" }}>
                  {
                      this.state.taskCodeRes.successNumber > 0 && this.state.taskCodeRes.errorNumber == 0 ?
                          <i className="iconfont icon-dagou icofontStatus"></i> : null
                  }
                  {
                      this.state.taskCodeRes.successNumber > 0 && this.state.taskCodeRes.errorNumber > 0 ?
                          <i className="iconfont icon-gantan icofontStatus"></i> : null
                  }
                  {
                      this.state.taskCodeRes.successNumber == 0 && this.state.taskCodeRes.errorNumber > 0 ?
                          <i className="iconfont icon-add-fill-hover-copy icofontStatus"></i> : null
                  }

                  <span style={{ fontSize: "16px" }}>铺货任务已提交，成功：<i style={{ color: "#5584FF" }}>{this.state.taskCodeRes.successNumber}</i>，失败：<i style={{ color: "#fe6f4f" }}>{this.state.taskCodeRes.errorNumber}</i></span>
                  {
                      this.state.taskCodeRes.errorNumber != 0 ? <text>失败详情如下：</text> : null
                  }
              </div>
              <div style={{ padding: "20px", fontSize: "16px" }}>可在<text style={{ color: "red" }}>铺货日志</text>中查看铺货结果</div>
              {
                  this.state.taskCodeRes.errorList.length > 0 ?
                      <div>
                          {
                              this.state.taskCodeRes.errorList.map((item) =>
                                  <text key={item}>{item}</text>
                              )
                          }
                      </div>
                      : null
              }

          </div>
          <div className="showModalWrap-box-commonfooter">
              <span className="showModalWrap-box-footer-btn" onClick={() => this.props.history.push('/distributionLog')}>铺货日志</span>
              <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.props.history.push('/')}>进入首页</span>

          </div>
      </ShowModal>

        <ShowModal top={100} wrapSkin="showSelectCategoryModule" zIndex={10000} showModal={this.state.showSelectCategoryModule} titleName={"选择类目"} cancelDailog={() => this.closeModal("showSelectCategoryModule")} hideBtn={true} showLeftTopBtn={true}>
          <SelectCategoryModule
            showSelectCategoryModule={this.state.showSelectCategoryModule}
            targetPlatformType={this.state.platformType}
            targetShopId={this.state.shopId}
            selectCategory={this.selectCategory}
          />
        </ShowModal>

        {/* 官方仓推广弹窗 */}
        <ShowModal wrapSkin="p-dialog" hideTitle={true} hideBtn={true} isHideCancleBtn={true} showModal={this.state.isOpenPromotionDialog}>
              <img src="https://www.dgjapp.com/public/images/huodong/2025-7-14-11-47.png" />
              <label>
                <input type="checkbox" id='not_askCheckbox' />
                <span>7日内不再提示</span>
              </label>
              <span onClick={() => this.closePromotionDialog()}>关闭</span>
              <a href='https://air.1688.com/app/channel-fe/distribution-work/sales_return_warehouse.html#/home' onClick={() => this.closePromotionDialog()} target='_blank'></a>
        </ShowModal>

        <ShowModal showModal={this.state.errorLinkDailog} titleName={"提示"} width={'500px'} titleIcon={<span className='iconfont icon-gantan warnColor' style={{fontSize:'24px',marginRight:'10px'}}></span>} cancelDailog={() => this.cancelModul('errorLinkDailog')} hideBtn={true} showLeftTopBtn={true}>
            <div style={{fontSize:'15px',padding:'10px',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
                <div>
                    {/* <span class="iconfont icon-gantan warnColor" style={{fontSize:'24px'}}></span> */}
                    <span>以下商品链接不符合规则，已为您自动过滤，请更换其他商品再试</span>
                </div>
                
                <ul className='errorLinkDailog-ul'>
                {
                  this.state.errorLink.map(link => <li onClick={()=>{ window.open(link,'_blank')}}> { link } </li>)
                }
                </ul>
            </div>
            <div className="showModalWrap-box-commonfooter">
                <span onClick={() => this.cancelModul('errorLinkDailog')} className="showModalWrap-box-footer-btn">我知道了</span>
            </div>
        </ShowModal>
        <ShowModal titleName={"提示"} width={"600px"} titleIcon={<span className='iconfont icon-gantan warnColor' style={{fontSize:'24px',marginRight:'10px'}}></span>} showModal={this.state.fenxiaojiaoChengDialog} cancelDailog={() => this.cancelModul("fenxiaojiaoChengDialog")} showLeftTopBtn={true} hideBtn={true}>
            <div className='fenxiaojiaoChengDialog'>
                <div className='fenxiaojiaoChengDialog-up'>

                    {
                      this.state.fenxiaoProductFaildList.findIndex(x => x.sourcePlatform == 'AlibabaZhuKe') != -1 ?
                      <div className='fenxiaojiaoChengDialog-up-title'>
                                            <span className='fenxiaojiaoChengDialog-up-text'>
                                                以下货源未获得分销授权，无法进行铺货、关联、更换。您可以换个货源或者联系供应商将该商品设置为支持分销 
                                                <span className='hover defColor'  onClick={() => {
                                                this.onChangeForm('fenxiaojiaoChengDialog', false);
                                                window.open('https://www.yuque.com/books/share/3b4df780-dec2-401c-8522-a75feeb63766/gtpzq3','_blank')
                                            }}> 分销教程</span></span>
                                        </div>:null
                    }
                                        
                    <div className='fenxiaojiaoChengDialog-up-content'>
                        {
                            this.state.fenxiaoProductFaildList.filter(x => x.sourcePlatform == 'AlibabaZhuKe').map(s => {
                                return <div className='fenxiaojiaoChengDialog-item'><a href={s.link} className='defColor' target='_blank'>{s.link}</a></div>
                            })
                        }
                    </div>

                    {
                      this.state.fenxiaoProductFaildList.findIndex(x => x.sourcePlatform == 'TaoteZhuKe') != -1 ?
                      <div className='fenxiaojiaoChengDialog-up-title'>
                          <span className='fenxiaojiaoChengDialog-up-text'>以下淘特商品不支持分销，请更换其他淘特商品再试</span>
                      </div>:null
                    }
                    
                    <div className='fenxiaojiaoChengDialog-up-content'>
                        {
                            this.state.fenxiaoProductFaildList.filter(x => x.sourcePlatform == 'TaoteZhuKe').map(s => {
                                return <div className='fenxiaojiaoChengDialog-item'><a href={s.link} className='defColor' target='_blank'>{s.link}</a></div>
                            })
                        }
                    </div>
                </div>
                <div className="showModalWrap-box-commonfooter">
                    <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn cancleBtn" onClick={() => {
                        this.onChangeForm('fenxiaojiaoChengDialog', false);
                    }
                    }>我知道了</span>
                    {
                        this.state.supplierProductIds.length > 0 ?
                            <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn" onClick={() => {
                                this.onChangeForm('fenxiaojiaoChengDialog', false);
                                this.onChangeForm('isShowByDistributionSelectCategory', true);
                            }}>继续铺货</span> : null
                    }
                </div>
            </div>
        </ShowModal>
          {/* 未设置运费模板 */}
          <ShowModal width={"500px"} showModal={this.state.isShowNotFreightTemplate} hideBtn={true} titleName="提示" >
                    <div className="showModalWrap-box-commonContent" style={{ fontSize: "16px", padding: "20px" }}>
                        <div>
                            <span>{this.state.notFreightTemplateValue}</span>
                        </div>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span className="showModalWrap-box-footer-btn" onClick={() => this.gotoDistributionSet()}>前往设置</span>
                        <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.cancelModul("isShowNotFreightTemplate")}>取消</span>
                    </div>
                </ShowModal>
        <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} />

        <NewUserGuide isShowNewUserGuide={this.state.isShowNewUserGuide} closeShowNewUserGuide={()=>{ this.closeShowNewUserGuide()}} successAuthBuyerShop={()=>{ this.successAuthBuyerShop()}}></NewUserGuide>
        {
            this.state.showPreviewDistributionDailog ?
                <PreviewDistributionList 
                                    targetPlatformType={getLoginShopInfo().loginShopPlatformType}
                                    targetShopId={getLoginShopInfo().loginShopId}
                                    showModal={this.state.showPreviewDistributionDailog} 
                                    productList={this.state.selectPreviewProductList}
                                    sureBatchPuhuo={this.previewSureBatchPuhuo} //点确定铺货按钮 函数
                                    cancelDailog={this.cancelPreviewDistribution} //点关闭铺货按钮 函数
                                />: null
        }
      </div>

    )
  }
}

export default Index;


// WEBPACK FOOTER //
// ./src/pages/index/index.jsx